export const showAnimation = (type) => {
  const bubbleElement = document.querySelector('.cce-widget__bubble ')
  if (!bubbleElement || bubbleElement.classList.contains('animated')) return

  if (type === 'pulse') {
    bubbleElement.querySelector('button').classList.add('animated')
    setTimeout(() => {
      bubbleElement.querySelector('button').classList.remove('animated')
    }, 5000)
  }
}
